import { FormBase } from 'core/components';

export default class ImportReferenceTypeEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'IMPORT_REFERENCE.EDIT.NAME_LABEL',
                    placeholder: 'IMPORT_REFERENCE.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'max:50', 'required'],
                },
            ],
        };
    }
}
